'use client';
import React from 'react';

import { TablePrimaryPropTypes } from './TablePrimary.types';
import styles from './TablePrimary.module.css';

const TablePrimary: React.FC<TablePrimaryPropTypes> = ({ className = '', headerRow, bodyRows }) => {
  const tableScrollRef: any = React.useRef(null);
  const hintLeftRef: any = React.useRef(null);
  const hintRightRef: any = React.useRef(null);

  React.useEffect(() => {
    const tableScroll = tableScrollRef.current;
    const hintLeft = hintLeftRef.current;
    const hintRight = hintRightRef.current;

    function updateScrollHints() {
      const scrollPercent = (tableScroll.scrollLeft / (tableScroll.scrollWidth - tableScroll.clientWidth)) * 100;
      // Use opacity to control visibility, enabling fade in/out
      hintRight.style.opacity = scrollPercent < 98 ? '1' : '0';
      hintLeft.style.opacity = scrollPercent > 2 ? '1' : '0';
    }

    tableScroll.addEventListener('scroll', updateScrollHints);
    // Initial check is not necessary for the left hint as it should not show initially
    // but necessary for right hint if the table is already at the end when loaded.
    updateScrollHints();

    // Cleanup function to remove the event listener on component unmount
    return () => tableScroll.removeEventListener('scroll', updateScrollHints);
  }, []);

  function countChildrenWithContent(headerRow: any): number {
    if (!headerRow?.props?.children || !Array.isArray(headerRow.props.children)) {
      return 0;
    }

    return headerRow.props.children.reduce((count: number, child: any) => {
      // Check if child has props and children
      if (!child?.props?.children) return count;

      // Check if children is an array with content
      const childChildren = child.props.children;
      if (Array.isArray(childChildren) && childChildren.length > 0) {
        // Check if the first element is an array with content or a string/non-empty value
        const firstChild = childChildren[0];
        if (Array.isArray(firstChild)) {
          if (firstChild.length > 0 && firstChild.some((item) => item !== '' && item !== undefined && item !== null)) {
            return count + 1;
          }
        } else if (firstChild !== '' && firstChild !== undefined && firstChild !== null) {
          return count + 1;
        }
      }

      return count;
    }, 0);
  }

  const contentCount = countChildrenWithContent(headerRow);

  return (
    <div className={`${styles.tableScroll} relative`}>
      <div ref={hintLeftRef} className={styles.scrollHint + ' ' + styles.scrollHintLeft}></div>

      <div ref={tableScrollRef} className={styles.tableScroll}>
        <table className={`${styles.roundedTable} ${styles.table} ${className}`}>
          {headerRow && (
            <thead className={`border-primary ${contentCount == 1 ? '' : styles.tableHeader}`}>{headerRow}</thead>
          )}
          {bodyRows && <tbody className={styles.blogTable}>{bodyRows}</tbody>}
        </table>
      </div>

      <div ref={hintRightRef} className={styles.scrollHint + ' ' + styles.scrollHintRight}></div>
    </div>
  );
};

export default TablePrimary;
